import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import * as R from 'ramda';
import { useAppDispatch } from '../../../../../hooks/hooks';
import { eApplications } from '../../../../../redux/e-applications/action';
import PageLoader from '../../../../../components/PageLoader';
import { selectEApplicationsQueryItems } from '../../../../../redux/e-applications/selector';
import EApplicationComponent from '../components/e-application.component';

const ManagementEApplication = () => {  
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const eApplicationQuery = useSelector(selectEApplicationsQueryItems)
const [isQuery, setIsQuery] = useState<boolean>(false)
const [isLoading, setIsLoading] = useState<boolean>(true)
const [
    selectEApplications,
    setSelectEApplications
  ] = useState<any>([])
  
  const fetchEapplicationQueryById= ()=>{
    dispatch(eApplications.query({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configurations/e-applications/query`,entity:'eApplications',jsonData:{
          
    Records: [
      {
        Id: 0
      }
    ]
  
}})).then(()=>{
  setIsQuery(true)
})




  }

  const handleInnerFormChange: any = (event: any, field: string, data: any) => {
    const fields = R.split(
      '.',
      field
    );
    const value = { ...data, [fields[1]]: event }// inner data update
    setSelectEApplications({ ...selectEApplications, [fields[0]]: value });
   
  }
  useEffect(
    () => {
    
        fetchEapplicationQueryById()
        setIsLoading(false)

    },
    []
  )
  useEffect(
    () => {
        
      if (isQuery) {
        setSelectEApplications(eApplicationQuery?.result?.items)
      }
    },
    [isQuery]
  ) 
const handleFormSubmit  = async (event: any) => {
    event.preventDefault(); 
     dispatch(eApplications.update({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configurations/e-applications`,entity:'eApplications',jsonData:{
            
    Records: [
        selectEApplications
    ]
 
}}))
.then(()=>{
    back()
  })
  }

const back=()=>{
  navigate('/management/configurations/e-applications')
} 

    return (
        <>

        {isLoading ? <PageLoader /> : 
          <EApplicationComponent 
          handleInnerFormChange={handleInnerFormChange}
          selectEApplications={selectEApplications}
          back={back}
          handleFormSubmit={handleFormSubmit}
          /> 
    } 
          </>
    )
    
    }
   
    export default ManagementEApplication;